import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  LIFECYCLE_STATUS_LABEL,
  PRODUCTION_STATUS_LABEL,
  SALES_STATUS_LABEL,
} from "constants/labels";
import { Predicates } from "libraries/predicates/predicates";
import { memo } from "react";
import { Tooltip } from "react-tooltip";
import { ExpandableSection } from "routes/skus/components/expandable-section";
import { IItemNumber } from "types/data.interface";

const ItemNumberViewAttributes = memo(
  ({ itemNumberData }: { itemNumberData: IItemNumber }) => {
    return (
      <ExpandableSection
        title={"Item Number Attributes"}
        sectionId={"2"}
        expandedByDefault
        className="mb-2"
      >
        <div className="row">
          <div className="col-md-3 form-group">
            <label className="form-label">Consumer Packaging Type</label>
            <textarea
              value={itemNumberData.itn_cptype}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>

          <div className="col-md-3 form-group">
            <label className="form-label">Consumer Packaging Language</label>
            <textarea
              value={itemNumberData.itn_cplang}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>

          <div className="col-md-3 form-group">
            <label className="form-label">Consumer Packaging Global Code</label>
            <textarea
              value={itemNumberData.itn_cpgcod}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>

          <div className="col-md-3 form-group">
            <label className="form-label">Consumer Packaging Global Name</label>
            <textarea
              value={itemNumberData.itn_cpgnam}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>
        </div>

        <div className="row ">
          <div className="col-md-3 form-group">
            <label className="form-label">Standard Pack</label>
            <input
              value={itemNumberData.itn_stdpak ?? ""}
              className="form-control"
              type="text"
              disabled
            />
          </div>

          <div className="col-md-3 form-group">
            <label className="form-label">Includes Leaflet or Manual</label>
            <textarea
              value={
                Predicates.isNotNullAndNotUndefined(itemNumberData.itn_inclfm) && itemNumberData.itn_inclfm === "Y"
                  ? itemNumberData.itn_inclfm
                    ? "Yes"
                    : "No"
                  : ""
              }
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>

          <div className="col-md-3 form-group">
            <label className="form-label">Leaflet or Manual Number</label>
            <textarea
              value={itemNumberData.itn_lfmnum}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>

          <div className="col-md-3 form-group">
            <label className="form-label">Leaflet or Manual Name</label>
            <textarea
              value={itemNumberData.itn_lfmnam}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>
        </div>

        <div className="row ">
          <div className="col-md-3 form-group">
            <label className="form-label">Marketing Material Type(s)</label>
            <textarea
              value={itemNumberData?.marketing_material?.id ? `${itemNumberData?.marketing_material?.id} - ${itemNumberData?.marketing_material?.name}`: ""}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>
          <div className="col-md-3 form-group">
            <label className="form-label">Plug Type</label>
            <textarea
              value={itemNumberData.itn_plgtyp}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>

          <div className="col-md-3 form-group">
            <label className="form-label">Plug Type Name</label>
            <textarea
              value={itemNumberData.itn_plgnam}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>

          <div className="col-md-3 form-group">
            <label className="form-label">UPC 12 Digits US</label>
            <textarea
              value={itemNumberData.itn_upc12d}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-3 form-group">
            <label className="form-label">EAN 13 Digits</label>
            <textarea
              value={itemNumberData.itn_ean13d}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>
          <div className="col-md-3 form-group">
            <label className="form-label">Regulatory Restrictions</label>
            <input
              value={itemNumberData.itn_restri}
              className="form-control"
              type="text"
              disabled
            />
          </div>

          <div className="col-md-3 form-group">
            <label className="form-label">Release Date</label>
            <input
              value={itemNumberData.itn_relsdt ? new Date(itemNumberData?.itn_relsdt).toDateString() : ""}
              className="form-control"
              type="text"
              disabled
            />
          </div>
          <div className="col-md-3 form-group">
            <Tooltip
              id="line-status"
              className="tooltip-text-box"
              place="right"
              noArrow={true}
            />
            <label className="form-label">{LIFECYCLE_STATUS_LABEL}</label>
            <span
              className="tooltip-span"
              data-tooltip-id="line-status"
              data-tooltip-html={`The ${LIFECYCLE_STATUS_LABEL.toLowerCase()} results from the combination of <br/> the ${PRODUCTION_STATUS_LABEL.toLowerCase()} and ${SALES_STATUS_LABEL.toLowerCase()}.`}
            >
              <FontAwesomeIcon icon={faCircleInfo} className="tooltip-icon" />
            </span>
            <textarea
              value={itemNumberData.itn_lifsts}
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>
        </div>
      </ExpandableSection>
    );
  },
);

export default ItemNumberViewAttributes;
